export default __webpack_public_path__ + "static/media/cabana-burrito.9684f89a.jpeg";